import React from 'react';
import { Typography } from '@mui/material';
import LegalPage from '../../components/LegalPage/LegalPage';

const Privacy = () => (
    <LegalPage product="LiftLog" title="Privacy Policy">
        <p><strong>Effective Date:</strong> March 22, 2026</p>
        <p>
            LiftLog ("we", "our", or "us") respects your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use the LiftLog mobile application.
        </p>

        <Typography variant="h6">1. Information We Collect</Typography>
        <p>We may collect the following information:</p>
        <ul>
            <li>Account Information (email, authentication data)</li>
            <li>Fitness Data (workouts, exercises, body weight, progress tracking)</li>
            <li>Device Information (app version, device type)</li>
            <li>Error &amp; Usage Data (via Sentry)</li>
        </ul>

        <Typography variant="h6">2. How We Use Your Information</Typography>
        <p>We use your data to:</p>
        <ul>
            <li>Provide and improve app functionality</li>
            <li>Store and track workout progress</li>
            <li>Authenticate users securely</li>
            <li>Monitor and fix errors</li>
        </ul>

        <Typography variant="h6">3. Data Storage</Typography>
        <p>Your data is securely stored using:</p>
        <ul>
            <li>Supabase (database &amp; authentication)</li>
            <li>Secure cloud infrastructure</li>
        </ul>

        <Typography variant="h6">4. Third-Party Services</Typography>
        <p>We use:</p>
        <ul>
            <li>Supabase (data storage &amp; authentication)</li>
            <li>Sentry (error monitoring)</li>
        </ul>
        <p>We do not sell or share your personal data with third parties.</p>

        <Typography variant="h6">5. Data Retention</Typography>
        <p>
            We retain your data as long as your account is active. You may request deletion at any time.
        </p>

        <Typography variant="h6">6. Account &amp; Data Deletion</Typography>
        <p>You can request deletion of your account and all associated data by:</p>
        <ul>
            <li>Using in-app deletion (if available), or</li>
            <li>Contacting us at: evolvedevlabs@gmail.com</li>
        </ul>

        <Typography variant="h6">7. Security</Typography>
        <p>
            We implement industry-standard security measures to protect your data.
        </p>

        <Typography variant="h6">8. Children's Privacy</Typography>
        <p>
            LiftLog is not intended for users under 13.
        </p>

        <Typography variant="h6">9. Changes to This Policy</Typography>
        <p>
            We may update this policy. Changes will be posted within the app.
        </p>

        <Typography variant="h6">10. Contact</Typography>
        <p>Email: evolvedevlabs@gmail.com</p>
    </LegalPage>
);

export default Privacy;
